// @flow
import React from 'react';
import * as css from './Spinner.module.css';

type PropsType = {
  className: string,
};

const Spinner = ({ className }: PropsType) => {
  const classNames = `${css.spinner} ${className}`;

  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames}
    >
      <circle cx="35" cy="35" r="32.1111" stroke="#C4C4C4" strokeWidth="4" />
      <path
        d="M5.75745 49.0713C10.3577 56.2475 14.3449 60.677 21.9504 64.2999C29.5558 67.9228 36.8794 68.3724 45.9352 65.0777"
        stroke="#F9F9F9"
        strokeWidth="5"
      />
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="rotate"
        from="0 0 0"
        to="360 0 0"
        dur="0.6s"
        repeatCount="indefinite"
      />
    </svg>
  );
};

export default React.memo(Spinner);
